import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "haFill-98-folder-upload",
  "use": "haFill-98-folder-upload-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"haFill-98-folder-upload\">\r\n    <path fill=\"#3E882E\" d=\"M16 27h-12.007c-1.094 0-1.993-0.891-1.993-1.991v-11.009h29v11.005c0 1.102-0.892 1.995-1.993 1.995h-12.007v-9l3.25 3.25 0.75-0.75-4.5-4.5-4.5 4.5 0.75 0.75 3.25-3.25v9zM2 13v-6.009c0-1.101 0.897-1.991 2.003-1.991h10.997l2 4h11.994c1.109 0 2.006 0.893 2.006 1.995v2.005h-29z\" />\r\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol